module.exports = __webpack_public_path__ + "static/media/animal-kingdom.9d1961ef.png";